import React, { Component } from 'react';
import classnames from 'classnames';

import InputGroupInfo from '../InputGroupInfo';

export default class FieldInputComponent extends Component {
  render() {
    const {
      field,
      form: { touched, errors },
      className,
      error,
      ...props
    } = this.props;
    const showError = touched[field.name] && errors[field.name];

    return (
      <InputGroupInfo
        errorClass={classnames(className, { 'animated shake error': !!error })}
        error={showError && errors[field.name]}
        classInput="form-input"
        {...props}
        {...field}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FieldInputComponent/FieldInputComponent.js